import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LoginRequest } from './login.model';
import { AppConfig } from '../common/model/appconfig';
import { Subscription } from 'rxjs';
import { LoginService } from './login.service';
import { Globals } from '../globals';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  errorMsg: string;
  request: LoginRequest;
  config: AppConfig;

  subscription: Subscription;
  loginEappsSer: Subscription;
  username: string;
  password: string;
  userDetails: any;
  isLoading: boolean;
  error: string;

  constructor(public loginService: LoginService, private router: Router, private formBuilder: FormBuilder,private globals : Globals) {
    this.request = new LoginRequest();
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: [''],
      password: ['']
    });

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onSubmit(isValid) {
    if (!isValid) {
      this.loginForm.markAllAsTouched();
    } else {
      this.loginEapps(this.f.username.value, this.f.password.value, 'null');
    }
  }

  get f() { return this.loginForm.controls; }

  loginEapps(createdBy, password, wUserName) {
    this.isLoading = true;
    this.error = '';
    this.loginEappsSer = this.loginService.loginUser(createdBy, password, wUserName).subscribe((res: any) => {
      var resp = this.globals.decrypt(JSON.parse(JSON.stringify(res.encResponse)));
      var data = JSON.parse(resp)
      this.isLoading = false;
      this.userDetails = JSON.parse(JSON.stringify(data));
      if (this.userDetails) {
        if (this.userDetails.wpwd) {
          sessionStorage.setItem('currentUser', JSON.stringify(this.userDetails));
          this.router.navigateByUrl('/doKyc');
        } else {
          this.error = 'Invalid Username/Password.'
        }
      } else {
        this.error = 'Invalid Username/Password.'
      }
    });

  }

}
